(function () {
  // Intercept fetch
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0];
    if (typeof url === 'string' && url.includes('/null')) {
      const error = new Error(`Fetch request to URL with /null: ${url}`);
      if (typeof (appsignal) != 'undefined') {
        appsignal.sendError(error);
      } else {
        console.error(error);
      }
    }
    return originalFetch.apply(this, args);
  };

  // Intercept XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (method.toUpperCase() === 'GET' && url.includes('/null')) {
      const error = new Error(`XMLHttpRequest GET request to URL with /null: ${url}`);
      if (typeof (appsignal) != 'undefined') {
        appsignal.sendError(error);
      } else {
        console.error(error);
      }
    }
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  // Intercept link clicks
  document.addEventListener('click', function (event) {
    const target = event.target.closest('a');
    const href = typeof target?.href === 'string' ? target.href : target?.getAttribute('href');
    if (href && href.includes('/null')) {
      const error = new Error(`Navigation to URL with /null: ${href}`);
      if (typeof (appsignal) != 'undefined') {
        appsignal.sendError(error);
      } else {
        console.error(error);
      }
    }
  });

  // Intercept window.location assignments
  const originalAssign = window.location.assign;
  const originalReplace = window.location.replace;

  function checkUrl(url) {
    if (url.includes('/null')) {
      const error = new Error(`Direct navigation to URL with /null: ${url}`);
      if (typeof (appsignal) != 'undefined') {
        appsignal.sendError(error);
      } else {
        console.error(error);
      }
    }
  }

  window.location.assign = function (url) {
    checkUrl(url);
    originalAssign.call(window.location, url);
  };

  window.location.replace = function (url) {
    checkUrl(url);
    originalReplace.call(window.location, url);
  };
})();
